import { render } from "./FilterFactoryVed.vue?vue&type=template&id=97bd6d0e&ts=true"
import script from "./FilterFactoryVed.vue?vue&type=script&lang=ts"
export * from "./FilterFactoryVed.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__